import { setToken, setUserName, setUserLastName } from "../../../utilities/storage";
import { AuthClient } from "../data/auth-client";

async function SignIn(email, password) {
  try {
    const authClient = new AuthClient();
    const response = await authClient.signIn(email, password);

    const data = response;

    const token = data.token;
    //const usuarioNombre = data.usuarioNombre;
    //const usuarioApellido = data.usuarioApellido;

    setToken(token);
    //setUserName(usuarioNombre);
    //setUserLastName(usuarioApellido);

    return {
      token,
      //usuarioNombre,
      //usuarioApellido,
    };
  } catch (err) {
    console.error("Sign In error", err);
    throw err;
  }
}

export default SignIn;
